import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateIdentificationDocumentQueries } from "web_myplann/Api/Client/invalidateIdentificationDocumentQueries";
import {
	putClientIdentificationDocumentsIdV2,
	type UpdateIdentificationDocumentRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type UpdateIdentificationDocumentVariables = {
	id: number;
	data: UpdateIdentificationDocumentRequestDTO;
};

export const useUpdateIdentificationDocumentMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			({ id, data }: UpdateIdentificationDocumentVariables) =>
				putClientIdentificationDocumentsIdV2(data, id),
		),
		onSuccess: () => {
			invalidateIdentificationDocumentQueries(queryClient);
		},
	});
};
